import { render } from "./KatSpinner.vue?vue&type=template&id=143003d7&scoped=true"
const script = {}

import "./KatSpinner.vue?vue&type=style&index=0&id=143003d7&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143003d7"]])

export default __exports__